import React from 'react';
import { TableCell, TableRow, Checkbox } from '@material-ui/core';
import { colors, Typography } from 'kangarootime-ui';
import ActionButton from '../GridView/ActionButton';
import Check from '../../../../assets/svg/check';
import Block from '../../../../assets/svg/block';
import moment from 'moment';

// Row also receives all props that 'TableView' receives
const Row = ({ photo, ...props }) => (
  <TableRow hover key={photo.group_image_id}>
    <TableCell>
      <Checkbox
        style={{ color: colors.brand_3 }}
        checked={props.selectedPhotoIds.includes(photo.id)}
        onChange={() => props.handlePhotoSelection(photo)}
      />
    </TableCell>
    <TableCell onClick={() => props.viewPhotoInLightbox(photo)}>
      <img src={photo.image} style={{ height: 36, width: 48, objectFit: 'cover', cursor: 'pointer' }} alt='' />
    </TableCell>
    <TableCell>
      <Typography>{photo.first_name} {photo.last_name}</Typography>
    </TableCell>
    <TableCell>
      <Typography>{photo.note.description || ''}</Typography>
    </TableCell>
    <TableCell>
      <Typography>{photo.employee_first_name} {photo.employee_last_name}</Typography>
    </TableCell>
    <TableCell>
      <Typography>{moment(photo.created_at).format('MMM Do, h:mm A')}</Typography>
    </TableCell>
    <TableCell align='right'>
      <div className='flex-1 flex-rows' style={{ justifyContent: 'flex-end' }}>
        <ActionButton
          icon={<Check fill={colors.success} />}
          onClick={() => props.approvePhotos([{
            photoId: photo.group_image_id,
            childId: photo.child_id
          }])}
        />
        <ActionButton
          icon={<Block fill={colors.danger} />}
          onClick={() => props.rejectPhotos([{
            photoId: photo.group_image_id,
            childId: photo.child_id
          }])}
        />
      </div>
    </TableCell>
  </TableRow>
);

export default Row;
